export interface PlaxmetalLine {
  id: string;
  name: string;
  category: string;
  description: string;
  photos: string[];
  url: string;
}

export const plaxmetalLines: PlaxmetalLine[] = [
  {
    id: 'brizza',
    name: 'Brizza',
    category: 'Cadeira Operativa',
    description: 'Uma das linhas mais populares da Plaxmetal, com encosto em tela mesh que favorece a ventilação e ergonomia avançada. Mecanismo Back System exclusivo.',
    photos: [
      'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/ab532543-c89b-4ae8-b0c2-e02a6f122f90-3808c7b1d21b7f528e17571994253961-1024-1024.webp',
    ],
    url: 'https://www.plaxmetal.com.br/produto/brizza',
  },
  {
    id: 'bix-x-plus',
    name: 'Bix X+',
    category: 'Cadeira Executiva',
    description: 'Cadeira executiva premium com encosto em tela mesh de alta resistência, mecanismo sincronizado e braços 4D. Conforto e tecnologia para executivos exigentes.',
    photos: [
      'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/095d47be-5dcc-4a30-a2e3-9571b86d95f5-ca1a496b6e89d0574a17572006209747-1024-1024.webp',
    ],
    url: 'https://www.plaxmetal.com.br/produto/bix-x-plus',
  },
  {
    id: 'beezi',
    name: 'Beezi',
    category: 'Cadeira Operativa',
    description: 'Design contemporâneo com opções de cores variadas, ideal para ambientes colaborativos e dinâmicos. Combina estética moderna com conforto ergonômico.',
    photos: [
      'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/32df56a1-4de2-4f1b-b7f8-9a7f5a07e47e-1-5cf9c69961cd306eba17615905713181-1024-1024.webp',
    ],
    url: 'https://www.plaxmetal.com.br/produto/beezi',
  },
  {
    id: 'fluidy',
    name: 'Fluidy Fixa',
    category: 'Cadeira Fixa',
    description: 'Cadeira diretor fixa com design ergonômico, encosto anatômico e acabamento premium. Ideal para salas de reunião e escritórios executivos.',
    photos: [
      'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/9b4c945c-9855-4b61-94c9-4c5630261013-d70a722cdec9e3fbff17615897403940-1024-1024.webp',
    ],
    url: 'https://www.plaxmetal.com.br/produto/fluidy',
  },
  {
    id: 'th2',
    name: 'TH2 Fixa',
    category: 'Cadeira Fixa',
    description: 'Cadeira fixa empilhável com estrutura em aço e assento/encosto em polipropileno. Ideal para auditórios, salas de treinamento e eventos corporativos.',
    photos: [
      'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/65b67bb5-d7bf-4287-b663-f3f7b002bb69-98fbeacfaba1ca957817651487702237-1024-1024.webp',
    ],
    url: 'https://www.plaxmetal.com.br/produto/th2',
  },
  {
    id: 'plus-size',
    name: 'Plus Size',
    category: 'Cadeira Reforçada',
    description: 'Cadeira operativa reforçada com capacidade de até 185kg. Estrutura extra-resistente, assento amplo e mecanismo robusto para máximo conforto e durabilidade.',
    photos: [
      'https://dcdn-us.mitiendanube.com/stores/004/083/073/products/b880f18d-66b0-455d-abfe-dff3717f1ded-9b951fe63d26fffda517572002266260-1024-1024.webp',
    ],
    url: 'https://www.plaxmetal.com.br/produto/plus-size',
  },
];
